angular.module('gym.calendar').controller('ManageAppointmentTypeCategoriesModal', ["$scope", "$modalInstance", "$timeout", "AppointmentTypeCategories", "categories", function($scope, $modalInstance, $timeout, AppointmentTypeCategories, categories) {
  var clearErrors, reload;
  $scope.categories = categories;
  $scope.newCategory = {};
  reload = function() {
    return AppointmentTypeCategories.getList({
      count: 200
    }).then(function(categories) {
      return $scope.categories = categories;
    });
  };
  clearErrors = function() {
    $scope.error = void 0;
    return $scope.newCategory.errors = void 0;
  };
  $scope.ok = function() {
    return $modalInstance.close();
  };
  $scope.save = function(category) {
    clearErrors();
    return category.save().then(function() {
      return reload();
    }, function(response) {
      return category.errors = response.data.errors;
    });
  };
  $scope.edit = function(category) {
    clearErrors();
    category._edit = true;
    return category.old_name = category.name;
  };
  $scope.reset = function(category) {
    clearErrors();
    category.name = category.old_name;
    category.old_name = void 0;
    category._edit = void 0;
    return category.errors = {};
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.create = function() {
    clearErrors();
    return AppointmentTypeCategories.post($scope.newCategory).then(function(category) {
      $scope.newCategory = {};
      return $scope.categories.push(category);
    }, function(response) {
      return $scope.newCategory.errors = response.data.errors;
    });
  };
  return $scope.delete = function(category) {
    clearErrors();
    return category.remove().then(function() {
      return reload();
    }, function(response) {
      return $scope.error = 'This category is in use and cannot be deleted at this time.';
    });
  };
}]);
